import icon from 'images/icons/svg/list.svg';
import React from 'react';
import { useParams } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import { InvoiceStatus } from 'services/EpdClient';
import { useArchivedVismaInvoices } from 'services/api/queries';
import styled from 'styled-components';
import { Container, EpdLink, H2, MainView } from 'styles/Styles.styled';

const ArchivedInvoices: React.FunctionComponent = () => {
  const { companyid, accountId } = useParams<{ companyid: string; accountId: string }>();
  const { data: invoices } = useArchivedVismaInvoices(accountId);

  return (
    <Container>
      <MainView>
        <H2>Archived invoices</H2>
        <InfoBox>
          <img src={icon} alt="information" style={{ height: '35px', marginRight: '1rem' }} />
          <div>
            Invoices created before April 2024 are archived here.
            <br />
          </div>
        </InfoBox>

        <List>
          {invoices?.drafts?.map((i) => (
            <ListRow key={i.invoiceId} to={EpdLinks.invoice(companyid, accountId, i.invoiceId ?? '')}>
              <img alt="" src={icon} />
              <span>{i.name}</span>
              <span>{i.invoiceStatus}</span>
            </ListRow>
          ))}
          {invoices?.invoices?.map((i) => (
            <ListRow key={i.invoiceId} to={EpdLinks.invoice(companyid, accountId, i.invoiceId ?? '')}>
              <img alt="" src={icon} />
              {i.invoiceStatus === InvoiceStatus.Declined ? <span>{'Quotation ' + i.name}</span> : <span>{i.name}</span>}
              <span>{i.invoiceStatus}</span>
            </ListRow>
          ))}
        </List>
      </MainView>
    </Container>
  );
};

export const InfoBox = styled.div`
  display: flex;
  padding: 1rem;
  border-left: solid 3px green;
  margin: 0.5rem 0;
  background-color: #f3f3f3;
  margin-bottom: 3rem;

  @media print {
    display: none;
  }
`;

const List = styled.div`
  padding: 0 1rem 2rem 1rem;
  display: flex;
  flex-direction: column;
`;

const ListRow = styled(EpdLink)`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  grid-column-gap: 0.5rem;
  border-bottom: 1px solid rgba(142, 142, 142, 0.25);

  img {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export default ArchivedInvoices;
